import { gql } from '@apollo/client/core'

/** Minimal event fields for home / teaser cards (see UpcomingEvents.vue). */
export const UPCOMING_EVENTS_EVENT_FRAGMENT = gql`
  fragment UpcomingEventsEvent on Event {
    name
    slug
    dateStart
    exclusive
    gallery
    club {
      ... on GetClubOutput {
        club {
          clubName
        }
      }
      ...ServerError
      ...UnauthorizedError
      ...UnauthenticatedError
    }
  }
`
